import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAnnouncement03 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.5 14C19.433 14 21 11.0899 21 7.5C21 3.91015 19.433 1 17.5 1M17.5 14C15.567 14 14 11.0899 14 7.5C14 3.91015 15.567 1 17.5 1M17.5 14L4.44354 11.6261C3.51605 11.4575 3.05231 11.3731 2.67733 11.189C1.91447 10.8142 1.34636 10.1335 1.11414 9.31593C1 8.91405 1 8.4427 1 7.5C1 6.5573 1 6.08595 1.11414 5.68407C1.34636 4.86649 1.91447 4.18577 2.67733 3.81105C3.05231 3.62685 3.51605 3.54254 4.44354 3.3739L17.5 1M4 12L4.39386 17.514C4.43126 18.0376 4.44996 18.2995 4.56387 18.4979C4.66417 18.6726 4.81489 18.8129 4.99629 18.9005C5.20232 19 5.46481 19 5.98979 19H7.7722C8.37234 19 8.67242 19 8.89451 18.8803C9.08966 18.7751 9.24434 18.6081 9.33423 18.4055C9.43653 18.1749 9.41351 17.8757 9.36748 17.2773L9 12.5",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAnnouncement03;
